module.exports = __webpack_public_path__ + "static/img/lianjie.327f77bf.png";